import { __decorate, __metadata } from "tslib";
import { Title } from '@cbbt/itf-onboarding-common';
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { NAME_PATTERN } from '../utils/regex.js';
export class IndividualName extends BaseMessage {
    title;
    firstName;
    middleName;
    lastName;
}
__decorate([
    Field.enum({
        description: 'Title of an individual',
        required: false,
        enum: Title,
    }),
    __metadata("design:type", String)
], IndividualName.prototype, "title", void 0);
__decorate([
    Field.string({
        description: 'First Name of an individual',
        required: true,
        maxLength: 30,
        pattern: NAME_PATTERN,
    }),
    __metadata("design:type", String)
], IndividualName.prototype, "firstName", void 0);
__decorate([
    Field.string({
        description: 'Middle Name of an individual',
        required: false,
        maxLength: 30,
    }),
    __metadata("design:type", String)
], IndividualName.prototype, "middleName", void 0);
__decorate([
    Field.string({
        description: 'Last Name of an individual',
        required: true,
        maxLength: 80,
        pattern: NAME_PATTERN,
    }),
    __metadata("design:type", String)
], IndividualName.prototype, "lastName", void 0);
//# sourceMappingURL=IndividualName.js.map